import template from './beacon.html';
import controller from './beacon.controller.js';

const shopBeaconComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default shopBeaconComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/beacon/beacon.component.js
 **/